// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"_3-Dtz-qNt4A_FA0oJWbeMf","success":"_1N7XYuYJ8sPwLomMgnUU8_","error":"_34veZGl4aZ5myFQfpLpIjh"};